// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Drawer that displays a purchase order's audit log — the chronological list
 * of lifecycle, field-edit, and third-party events recorded for the order.
 */
import { AuditDrawer } from '@/components/audit-drawer';
import { PurchaseOrderAuditList } from '@/purchase-order/components/purchase-order-audit-list';

interface Props {
  purchaseOrderKey: string;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

export function PurchaseOrderAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Purchase order audit log"
      disclosure={props.disclosure}
      auditLog={
        <PurchaseOrderAuditList purchaseOrderKey={props.purchaseOrderKey} />
      }
    />
  );
}
